import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import DivButton from '../../../components/common/DivButton';
import NumberPanelTitle from '../../../components/play/Lottery/picker/NumberPanelTitle';
import { MORE_LINES_SIGNAL } from '../../../components/play/Types/Constants';
import {
    BONUS_NUMBERS,
    isBonusNumberPickable,
    PRIMARY_NUMBERS,
    RANGE_FROM,
    RANGE_TO,
} from '../../../components/play/helpers/linesHelper';
import useLinesHelper from '../../../components/play/helpers/useLinesHelper';

import { RootState } from '../../../components/play/redux/store';
import { clickLinesManageButton } from '../../../components/play/redux/storeSlice';
import { rangeArray } from '../../../utils/helpers';
import { isThankYouLotto } from '../../../utils/template';

export default function AddNewLineNumberPanel() {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isTemplateThankYouLotto = useMemo(() => isThankYouLotto(), []);
    const { lottery } = useSelector((state: RootState) => state.playStore);

    const { ranges, numbersPerLine } = useLinesHelper();
    const isMegaJackpot = lottery?.display_slug?.startsWith('mega-jackpot');

    if (!isTemplateThankYouLotto) {
        return null;
    }

    function primaryLines() {
        return (
            <div className="mt-2 text-center">
                <div className="lotto-grid lotto-number-grid">{printLine(PRIMARY_NUMBERS, 'lotto-ball')}</div>
            </div>
        );
    }

    function bonusLines() {
        if (numbersPerLine[BONUS_NUMBERS] <= 0 || !isBonusNumberPickable(lottery)) {
            return null;
        }

        const title = (
            <div className="text-center text-white mt-3">
                {t(`playPicker.lottery.${isMegaJackpot ? 'pickExtraNumber' : 'pickBonusNumber'}`, {
                    count: numbersPerLine[BONUS_NUMBERS],
                    name: lottery.bonusNumberName,
                })}
            </div>
        );

        return (
            <>
                {title}
                <div className="lotto-grid lotto-star-grid mt-2">{printLine(BONUS_NUMBERS, 'lotto-star')}</div>
            </>
        );
    }

    function printLine(rangeIndex: number, ballClass: string) {
        return rangeArray(ranges[rangeIndex][RANGE_FROM], ranges[rangeIndex][RANGE_TO]).map((n) => (
            <DivButton key={n} onClick={() => null} className={ballClass}>
                {n}
            </DivButton>
        ));
    }

    function addNewLine() {
        dispatch(clickLinesManageButton(MORE_LINES_SIGNAL));
    }

    return (
        <div className="lotto-card">
            <div className="d-flex justify-content-between align-items-center">
                <button type="button" className="btn lucky-dip-btn" disabled>
                    {/* TODO: Add translation */}
                    Lucky Dip
                </button>
                <button type="button" className="btn trash-btn" disabled>
                    <i className="bi bi-trash" />
                </button>
            </div>

            <div className="text-center text-white mt-3">
                <NumberPanelTitle />
            </div>

            <div className="purchase-line">
                {primaryLines()}
                {bonusLines()}
            </div>

            <div className="inactive-card-cover">
                <button type="button" className="btn btn-primary px-4" onClick={addNewLine}>
                    {/* TODO: Add translation */}
                    Add Line
                </button>
            </div>
        </div>
    );
}
